import {
  FilterMode,
  RoleCreateMutationVariables,
  Role_OrderBy,
  Role,
  SortOrder,
  Role_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";
import { fieldByLang } from "../../common/utils";
import { buildCreateOne } from "../../common/services/crudServices";

export const roleService = {
  createOne: buildCreateOne(
    (roleCreateVariables: RoleCreateMutationVariables) =>
      async (token: string, activityStore: any) => {
        const api = getApiInstance(token, activityStore);
        const result = await api.roleCreate(roleCreateVariables);
        return result.roleCreate;
      }
  ),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.roleOne({ id });
    return result.roleOne as Role;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    language: string = "es",
    orderBy: Role_OrderBy[] | null = null,
    filter: Role_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: Role_Filter | undefined;
    if (searchValue !== "") {
      where = {
        [fieldByLang("name", language)]: {
          contains: searchValue,
          mode: FilterMode.Insensitive,
        },
      };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.roleListWithOffset({
      offset,
      take,
      orderBy: orderBy
        ? orderBy
        : [{ [fieldByLang("name", language)]: SortOrder.Asc }],
      where,
    });
    const list = nullToUndefinedRecursive(result.roleListWithOffset) as Role[];
    return { list, orderBy };
  },
};
